
import React from 'react';
import { Users, CircleCheck } from 'lucide-react';

const EmotionalBenefits: React.FC = () => {
  return (
    <section className="py-16 bg-[#D2B48C] relative" aria-labelledby="benefits-heading">
      <div className="container mx-auto px-6 max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-8 text-[#8B4513]" id="benefits-heading">
          Best NYC Feline History Walking Tours
        </h2>
        <p className="text-lg mb-10 px-6 font-opensans text-[#8B4513]">
          In just two hours, you'll meet the cats who shaped NYC—like the feline mascot of a 19th-century firehouse—and carry their stories with you for years. Our tours deepen your connection to New York's past, transforming how you see the city forever.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-[#F5F5DC] p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-4 text-[#C46829]">
              <Users size={24} className="mr-3" aria-hidden="true" />
              <h3 className="text-xl font-bold font-montserrat">Meet Fellow Cat Lovers</h3>
            </div>
            <p className="text-[#8B4513] font-opensans">
              The only NYC tour that brings cat enthusiasts together! Share your passion with like-minded people while exploring feline history in a fun, social atmosphere.
            </p>
          </div>
          <div className="bg-[#F5F5DC] p-6 rounded-lg shadow-elegant">
            <div className="flex items-center mb-4 text-[#C46829]">
              <CircleCheck size={24} className="mr-3" aria-hidden="true" />
              <h3 className="text-xl font-bold font-montserrat">98% of guests rate our tours 5 stars</h3>
            </div>
            <p className="text-[#8B4513] font-opensans">
              Join the hundreds of visitors who've discovered NYC's hidden feline history through our unique walking tours.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmotionalBenefits;
